import { HMO, HMOType } from "constants/hmo";
import pxToRem from "assets/theme/functions/pxToRem";

/**
 * HMO Button Style Overrides
 * Defines MuiButton root customizations for each HMO portal
 *
 * React 19 Best Practice: Pre-computed module-level constants
 * Since HMO is detected once and never changes, we pre-compute all possible values
 */

type ButtonRootOverrides = {
  borderRadius?: string;
  height?: string;
  minHeight?: string;
};

const HMO_BUTTON_ROOT: Record<HMO, ButtonRootOverrides> = {
  [HMO.LEUMIT]: {
    borderRadius: pxToRem(40),
    height: pxToRem(50),
    minHeight: pxToRem(50),
  },

  [HMO.MACCABI]: {},

  [HMO.CLALIT]: {},

  [HMO.MEUCHEDET]: {},

  [HMO.CLINICAL_TRIAL]: {},
};

const DEFAULT_BUTTON_ROOT: ButtonRootOverrides = {};

/**
 * Returns HMO-specific MuiButton root style overrides
 * @param hmo - HMO identifier or null for default
 * @returns Button root style overrides or empty object for default theme
 */
export function getHmoButtonRoot(hmo: HMOType): ButtonRootOverrides {
  if (!hmo) {
    return DEFAULT_BUTTON_ROOT;
  }

  return HMO_BUTTON_ROOT[hmo] || DEFAULT_BUTTON_ROOT;
}
